import { render, staticRenderFns } from "./LetterKeys.vue?vue&type=template&id=68b5ed52&"
import script from "./LetterKeys.vue?vue&type=script&lang=ts&"
export * from "./LetterKeys.vue?vue&type=script&lang=ts&"
import style0 from "./LetterKeys.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports